import {
    chakra,
    Flex
} from '@chakra-ui/react';

export const HBox = chakra(Flex, {
    label: 'HBox',
    baseStyle: { height: 'calc(100vh - 60px)' }
});
